import { toast } from 'react-toastify';

export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8080';

export const getImageUrl = (imagePath, placeholderText = "No Image") => {
    if (!imagePath) {
        // Tự động tạo một ảnh SVG khung xám chữ xám ngay trong trình duyệt
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400"><rect width="400" height="400" fill="#f3f4f6"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="sans-serif" font-size="20" font-weight="bold" fill="#9ca3af">${placeholderText}</text></svg>`;
        return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
    }
    if (imagePath.startsWith('http') || imagePath.startsWith('blob')) return imagePath;
    
    return `${BASE_URL}${imagePath}`;
};

export const createQuillImageHandler = (quillRef, uploadApiFunction, folderName) => {
    // Trả về một function để Quill gọi khi bấm nút Image
    return () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            if (!file) return;

            if (file.size > 5 * 1024 * 1024) {
                toast.error("Vui lòng chọn ảnh nhỏ hơn 5MB!");
                return;
            }

            // Kiểm tra xem ref có tồn tại không
            if (!quillRef || !quillRef.current) {
                console.error("Quill ref không tồn tại!");
                return;
            }

            const quillObj = quillRef.current.getEditor();
            const range = quillObj.getSelection(true); // Lấy vị trí con trỏ
            const toastId = toast.loading("Đang tải ảnh lên...");

            try {
                const formData = new FormData();
                formData.append('file', file); // Tên field gửi lên Backend

                // 👉 ĐÃ THÊM: Nếu có truyền tên thư mục thì nhét vào formData gửi lên Server
                if (folderName) {
                    formData.append('folder', folderName);
                }

                const response = await uploadApiFunction(formData);
                
                // Lọc lấy URL chuẩn xác
                let imageUrl = response?.data?.url || response?.url || response?.data || response; 
                if (typeof imageUrl === 'object' && imageUrl.url) {
                    imageUrl = imageUrl.url;
                }

                const fullImageUrl = imageUrl.startsWith('http') ? imageUrl : `${BASE_URL}${imageUrl}`;

                // Chèn ảnh vào editor
                quillObj.insertEmbed(range.index, 'image', fullImageUrl);
                quillObj.setSelection(range.index + 1);

                toast.update(toastId, { render: "Tải ảnh thành công!", type: "success", isLoading: false, autoClose: 2000 });
            } catch (error) {
                console.error("Lỗi upload ảnh Quill:", error);
                toast.update(toastId, { render: "Lỗi tải ảnh! Vui lòng thử lại.", type: "error", isLoading: false, autoClose: 3000 });
            }
        };
    };
};

export const cleanHtmlContent = (html) => {
    if (!html) return '';
    
    return html
        // 1. BẮT BỆNH UNIKEY: Chỉ đổi &nbsp; thành dấu cách trơn nếu nó đứng kẹt giữa 2 ký tự văn bản.
        // [^\s<>&] nghĩa là: Bỏ qua nếu đứng cạnh dấu cách, dấu < > (thẻ HTML), hoặc dấu & (của &nbsp; khác).
        // Nhờ vậy, toàn bộ Tab và thụt lề ở đầu dòng sẽ được giữ nguyên 100%!
        .replace(/([^\s<>&])(?:&nbsp;|\u00a0)([^\s<>&])/g, '$1 $2')
        
        // 2. DIỆT RÁC LIST: Xóa các ký tự thừa (*, -) do copy từ Word vào đầu thẻ <li>
        .replace(/(<li[^>]*>)\s*(<span[^>]*>)?\s*([*\-•o○])\s*(<\/span>)?\s*/gi, '$1'); 
};

export const generateSlug = (str) => {
    if (!str) return '';
    return str.toString().toLowerCase()
        .replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a")
        .replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e")
        .replace(/ì|í|ị|ỉ|ĩ/g, "i")
        .replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o")
        .replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u")
        .replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y")
        .replace(/đ/g, "d")
        .replace(/[^a-z0-9 -]/g, "") // Xóa ký tự đặc biệt
        .replace(/\s+/g, "-") // Đổi khoảng trắng thành gạch ngang
        .replace(/-+/g, "-") // Xóa gạch ngang liên tiếp
        .replace(/^-+|-+$/g, ""); // Xóa gạch ngang ở đầu và cuối
};

// Hàm phụ trợ: Chuyển đổi chuỗi Base64 thành File Object
export const dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) { u8arr[n] = bstr.charCodeAt(n); }
    return new File([u8arr], filename, { type: mime });
};

// Hàm phụ trợ: Quét HTML, bóc tách Base64, Upload và thay thế bằng URL
export const processHtmlAndUploadImages = async (htmlContent, folderName, uploadApiFunction, uploadExternalApiFunction) => {
    if (!htmlContent) {
        return htmlContent;
    }

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    const images = tempDiv.getElementsByTagName('img');
    
    console.log(`-> Tìm thấy ${images.length} thẻ <img> trong nội dung.`);
    
    let hasChanges = false;

    for (let i = 0; i < images.length; i++) {
        const img = images[i];
        const src = img.getAttribute('src');

        if (!src) continue;

        // TRƯỜNG HỢP 1: ẢNH LÀ DẠNG BASE64 (Copy trực tiếp từ file/clipboard)
        if (src.startsWith('data:image/')) {
            try {
                const extension = src.match(/data:image\/(.*?);/)[1];
                const fileName = `editor_img_${Date.now()}_${i}.${extension}`;
                const file = dataURLtoFile(src, fileName);

                const formData = new FormData();
                formData.append('file', file);
                if (folderName) formData.append('folder', folderName);

                const response = await uploadApiFunction(formData);
                hasChanges = true;
                
                let uploadedUrl = response?.data?.url || response?.url || response?.data || response;
                if (typeof uploadedUrl === 'object' && uploadedUrl.url) uploadedUrl = uploadedUrl.url;

                if (typeof uploadedUrl !== 'string') throw new Error("Không thể trích xuất URL từ phản hồi");
                
                const fullImageUrl = uploadedUrl.startsWith('http') ? uploadedUrl : `${BASE_URL}${uploadedUrl}`;
                img.setAttribute('src', fullImageUrl);
            } catch (error) {
                console.error(`-> LỖI KHI UPLOAD ẢNH BASE64:`, error);
            }
        } 
        
        // TRƯỜNG HỢP 2: ẢNH LÀ LINK TỪ WEB KHÁC (Bắt đầu bằng http và không chứa tên miền của mình)
        // Lưu ý: Cần import BASE_URL vào file này nếu chưa có
        else if (src.startsWith('http') && !src.includes(BASE_URL)) {
            // 👉 ĐÃ SỬA: Gọi Backend Spring Boot để tải ảnh thay vì fetch trực tiếp
            if (!uploadExternalApiFunction) continue; 
            
            try {
                console.log(`-> Nhờ Backend tải ảnh: ${src}`);
                const response = await uploadExternalApiFunction(src, folderName);
                
                hasChanges = true;
                let uploadedUrl = response?.data?.url || response?.url || response?.data || response;
                if (typeof uploadedUrl === 'object' && uploadedUrl.url) uploadedUrl = uploadedUrl.url;

                const fullImageUrl = uploadedUrl.startsWith('http') ? uploadedUrl : `${BASE_URL}${uploadedUrl}`;
                img.setAttribute('src', fullImageUrl);
                
            } catch (error) {
                console.error(`-> BACKEND TẢI ẢNH THẤT BẠI (${src}):`, error);
            }
        }
    }

    return hasChanges ? tempDiv.innerHTML : htmlContent;
};

export const fixHtmlImageUrls = (html) => {
    if (!html) return '';

    // Khai báo tên miền chính thức của bạn (khuyên dùng HTTPS). 
    // Có thể dùng biến môi trường để linh hoạt giữa lúc code (localhost) và lúc deploy.
    const targetDomain = process.env.REACT_APP_API_URL || 'https://thanhnampc.vn';

    let fixedHtml = html;

    // 1. Quét và thay thế toàn bộ địa chỉ IP cứng bị lưu nhầm trong DB thành tên miền chuẩn
    fixedHtml = fixedHtml.replace(/http:\/\/171\.244\.8\.71/g, targetDomain);

    // 2. Dự phòng: Nếu DB lưu đường dẫn tương đối (VD: /uploads/image_...), ta tự động nối tên miền vào
    fixedHtml = fixedHtml.replace(/<img[^>]+src=["'](\/[^"']+)["']/g, (match, path) => {
        return match.replace(path, `${targetDomain}${path}`);
    });

    return fixedHtml;
};